import { motion, useScroll } from "framer-motion";
import { cn } from "@/lib/utils";

export default function ScrollProgress({ target, className }) {
  const { scrollYProgress } = useScroll(target ? { container: target } : {});

  return (
    <motion.div
      className={cn("fixed top-0 left-0 right-0 h-0.5 bg-amber-400 origin-left z-[60]", className)}
      style={{ scaleX: scrollYProgress }}
    />
  );
}
